// Shared content data for VistaWash site

export const COMPANY = {
  name: "VistaWash",
  phone_display: "0497 13 02 65",
  phone_link: "tel:0497130265",
  whatsapp: "https://wa.me/32497130265?text=Bonjour%20VistaWash%2C%20je%20souhaite%20un%20devis%20pour%20mon%20v%C3%A9hicule.",
  email: "vistawash@hotmail.com",
  address_line1: "Rue du Cimetière 3",
  address_line2: "6200 Châtelet, Belgique",
  address_full: "Rue du Cimetière 3, 6200 Châtelet",
};

export const SITE_URL = "https://vistawashdetailing.be";

export const LEGAL = {
  legal_name: "VistaWash",
  legal_form: "Entreprise individuelle",
  bce: "À compléter",
  tva: "BE 0XXX.XXX.XXX",
  publication_director: "M. Le gérant de VistaWash",
};

export const NAV = [
  { label: "Accueil", to: "/" },
  {
    label: "Services",
    children: [
      { label: "Nettoyage intérieur / extérieur", to: "/nettoyage-automobile-premium" },
      { label: "Polissage", to: "/polissage-automobile" },
      { label: "Traitement céramique", to: "/traitement-ceramique" },
    ],
  },
  { label: "Avis", to: "/#avis", hash: true },
  { label: "Réalisations", to: "/galerie" },
  { label: "À propos", to: "/a-propos" },
];

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_site-gen-40/artifacts/w8qlhov1_CAB43020-D96D-4806-BF75-FFC804326E21.png";

export const SERVICES = [
  {
    id: "nettoyage-int",
    title: "Nettoyage Intérieur Complet",
    short: "Aspiration profonde, traitement cuir, plastiques et tissus.",
    icon: "Brush",
    number: "01",
    image: "https://images.pexels.com/photos/26871052/pexels-photo-26871052.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    id: "nettoyage-ext",
    title: "Nettoyage Extérieur",
    short: "Lavage manuel pH neutre, jantes, séchage microfibre premium.",
    icon: "SprayCan",
    number: "02",
    image: "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?auto=format&fit=crop&q=80&w=1200",
  },
  {
    id: "detailing",
    title: "Detailing Automobile",
    short: "Préparation esthétique complète, intérieur + extérieur.",
    icon: "Car",
    number: "03",
    image: "https://images.pexels.com/photos/14615262/pexels-photo-14615262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    id: "polissage",
    title: "Polissage Automobile",
    short: "Correction des micro-rayures, hologrammes, restauration brillance.",
    icon: "Sparkles",
    number: "04",
    image: "https://images.pexels.com/photos/14908957/pexels-photo-14908957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    id: "ceramique",
    title: "Protection Céramique",
    short: "Nano-revêtement 9H, effet hydrophobe, protection longue durée.",
    icon: "ShieldCheck",
    number: "05",
    image: "https://images.unsplash.com/photo-1605515298946-d062f2e9da53?auto=format&fit=crop&q=80&w=1200",
  },
  {
    id: "preparation",
    title: "Préparation Esthétique",
    short: "Reconditionnement pour vente, exposition ou livraison VIP.",
    icon: "Wrench",
    number: "06",
    image: "https://images.unsplash.com/photo-1706811422966-24bfa91695c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const ZONES = [
  "Châtelet",
  "Charleroi",
  "Châtelineau",
  "Gilly",
  "Couillet",
  "Gerpinnes",
  "Fleurus",
  "Sambreville",
  "Jemeppe-sur-Sambre",
  "Namur",
];

export const TESTIMONIALS = [
  {
    name: "Benoit Devulder",
    meta: "Local Guide · 88 avis · 9 photos",
    date: "il y a un mois",
    text: "Super expérience. VistaWash a donné une nouvelle vie a ma Qashqai de 11ans. Je recommande les yeux fermés.",
    rating: 5,
    avatar: "https://ui-avatars.com/api/?name=Benoit+Devulder&background=D90000&color=fff&size=128&bold=true&font-size=0.45",
    initial: "B",
    avatarBg: "#D90000",
  },
  {
    name: "Zine Lachachi",
    meta: "4 avis · 1 photo",
    date: "il y a 4 mois",
    text: "Service de lavage exceptionnel ! La personne qui s'est occupée de mon véhicule a fait preuve d'une minutie rare et d'une connaissance parfaite des matériaux. Chaque surface (intérieur et extérieur) a été traitée avec les produits adéquats, sans aucun produit agressif. Le résultat est bluffant : ma voiture est comme neuve. Un vrai professionnalisme allié à une grande gentillesse. Je recommande les yeux fermés !",
    rating: 5,
    avatar: null,
    initial: "Z",
    avatarBg: "#8a4fff",
  },
  {
    name: "Carl PERRICAUD (Noirmouson)",
    meta: "Local Guide · 70 avis · 686 photos",
    date: "il y a 4 mois",
    text: "Belle expérience, très bel accueil, le service impeccable.",
    rating: 5,
    avatar: "https://ui-avatars.com/api/?name=Carl+Perricaud&background=8B6F47&color=fff&size=128&bold=true",
    initial: "C",
    avatarBg: "#8B6F47",
  },
  {
    name: "François Creuse",
    meta: "4 avis · 1 photo",
    date: "il y a 4 mois",
    text: "Professionnel, travail au top ! Je recommande.",
    rating: 5,
    avatar: "https://ui-avatars.com/api/?name=Francois+Creuse&background=E07B2A&color=fff&size=128&bold=true",
    initial: "F",
    avatarBg: "#E07B2A",
  },
  {
    name: "Pierre De Smet",
    meta: "4 avis",
    date: "il y a 4 mois",
    text: "Parfait... Rien à dire... très pro.",
    rating: 5,
    avatar: null,
    initial: "P",
    avatarBg: "#3a4a52",
  },
];

export const FAQ = [
  {
    q: "Combien coûte un nettoyage automobile chez VistaWash ?",
    a: "Nos prestations débutent à partir de 79 € et varient selon la taille du véhicule, son état et le niveau de finition souhaité.",
  },
  {
    q: "Quelle est la différence entre un lavage classique et un detailing automobile ?",
    a: "Un detailing est une prestation beaucoup plus approfondie visant à nettoyer, restaurer et valoriser le véhicule dans les moindres détails, à l'intérieur comme à l'extérieur.",
  },
  {
    q: "Combien de temps faut-il pour nettoyer mon véhicule ?",
    a: "Selon la formule choisie et l'état du véhicule, une prestation peut durer de 2 à 6 heures.",
  },
  {
    q: "Réalisez-vous les prestations en atelier ?",
    a: "Oui, nous accueillons principalement nos clients dans notre atelier à Châtelet afin de garantir les meilleures conditions de travail et le meilleur résultat possible.",
  },
  {
    q: "Comment réserver un rendez-vous ?",
    a: "Le plus simple : remplir le formulaire de devis, nous écrire sur WhatsApp au 0497 13 02 65, ou nous appeler directement. Réponse rapide par WhatsApp, lun–sam 9h–18h.",
  },
];

export const STATS = [
  { value: "500+", label: "Véhicules traités" },
  { value: "5★", label: "Note moyenne" },
  { value: "9H", label: "Dureté céramique" },
  { value: "24h", label: "Réponse devis" },
];

export const BRANDS = [
  { name: "Koch Chemie", logo: "https://logo.clearbit.com/koch-chemie.de" },
  { name: "Gyeon", logo: "https://logo.clearbit.com/gyeonquartz.com" },
  { name: "CarPro", logo: "https://logo.clearbit.com/carpro.com" },
  { name: "Gtechniq", logo: "https://logo.clearbit.com/gtechniq.com" },
  { name: "Sonax", logo: "https://logo.clearbit.com/sonax.com" },
  { name: "Meguiar's", logo: "https://logo.clearbit.com/meguiars.com" },
  { name: "Chemical Guys", logo: "https://logo.clearbit.com/chemicalguys.com" },
  { name: "Nanolex", logo: "https://logo.clearbit.com/nanolex.de" },
];

// Car brands, biggest/most prestigious first
export const CAR_BRANDS = [
  { name: "Porsche", logo: "https://logo.clearbit.com/porsche.com" },
  { name: "Ferrari", logo: "https://logo.clearbit.com/ferrari.com" },
  { name: "Lamborghini", logo: "https://logo.clearbit.com/lamborghini.com" },
  { name: "Mercedes-Benz", logo: "https://logo.clearbit.com/mercedes-benz.com" },
  { name: "BMW", logo: "https://logo.clearbit.com/bmw.com" },
  { name: "Audi", logo: "https://logo.clearbit.com/audi.com" },
  { name: "Bentley", logo: "https://logo.clearbit.com/bentleymotors.com" },
  { name: "Aston Martin", logo: "https://logo.clearbit.com/astonmartin.com" },
  { name: "McLaren", logo: "https://logo.clearbit.com/mclaren.com" },
  { name: "Rolls-Royce", logo: "https://logo.clearbit.com/rolls-roycemotorcars.com" },
  { name: "Maserati", logo: "https://logo.clearbit.com/maserati.com" },
  { name: "Range Rover", logo: "https://logo.clearbit.com/landrover.com" },
  { name: "Jaguar", logo: "https://logo.clearbit.com/jaguar.com" },
  { name: "Lexus", logo: "https://logo.clearbit.com/lexus.com" },
  { name: "Tesla", logo: "https://logo.clearbit.com/tesla.com" },
  { name: "Volkswagen", logo: "https://logo.clearbit.com/volkswagen.com" },
  { name: "Volvo", logo: "https://logo.clearbit.com/volvocars.com" },
  { name: "Alpine", logo: "https://logo.clearbit.com/alpinecars.com" },
];
